/**
 * Holds the constants for EnvironmentClient cordova plugin
 */
export class EnvironmentPluginConstants {
    public static readonly ENVIRONMENT_PLUGIN_NAME = 'EnvironmentClient'
    public static readonly ACTION_SET_IIB_TOKEN = 'setIibToken'
    public static readonly ACTION_SET_STORE_DETAILS = 'setStoreDetails'
    public static readonly ACTION_CLEAR_SHAREDPREFS_KEY = 'clearSharedPrefsEntry'
    public static readonly IIB_ID_TOKEN_KEY = 'iibIdToken'
    public static readonly ACTION_CLEAR_COOKIES = 'clearCookies'
    public static readonly ACTION_SET_IHM_LOGIN_TOKEN = 'setSharedPrefEncryptedItem'
    public static readonly ACTION_GET_IHM_LOGIN_TOKEN = 'getSharedPrefEncryptedItem'
    public static readonly ACTION_SET_SHARED_PREFERENCES = 'setSharedPrefEncryptedItem'
    public static readonly ACTION_GET_SHARED_PREFERENCES = 'getSharedPrefEncryptedItem'
    public static readonly ACTION_GET_SHARED_PREFERENCES_UNENCRYPTED = 'getSharedPrefItem'
    public static readonly ACTION_SET_SHARED_PREFERENCES_UNENCRYPTED = 'setSharedPrefItem'
}
